/*
 * File: detail.ts
 * Project: meki
 * File Created: Wednesday, 10th November 2021 4:58:00 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 1st December 2023 11:26:50 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { ResolverParams } from '@queries/queries.interfaces';
import { Order } from '@interfaces';

export const OrderDeliveryOptions = () => gql`
  query OrderDeliveryOptions($params: OrderDeliveryOptionsParams!) {
    orderDeliveryOptions(params: $params) {
      dates
      currentOrderId
      deliveryCost
      orders {
        deliveryDate
        deliveryType
        deliveryCost
        deliveryCoupon
        totalCost
        orderDetails {
          quantity
          product {
            id
            name
            imagesUrl
            activePrinciple
            concentration
            unit
            prescriptionType
            quantity
            discount {
              price
              type
              stockRestriction
              dateRestriction
              listPrice
            }
            format
            price
            container
            containerQuantity
            concentration
            laboratory
            availability {
              stock
              statusWithoutStock
              status
            }
            metadata {
              refrigerated
            }
          }
          price
          type
          listPrice
        }
      }
    }
  }
`;

export type GetCheckoutDetailQueryResponse = {
  orderDeliveryOptions: {
    orders: Order[];
    dates: Date[];
    deliveryCost: number;
    currentOrderId: number;
  }[];
};

export type GetCheckoutDetailQueryParams = ResolverParams<{
  orderUuid: string;
}>;
